import ITagData from '../interfaces/ITagData'

// eslint-disable-next-line import/prefer-default-export
export const mapTags = (tags ?: ITagData[]) : string[] => tags?.map((tag : ITagData) => tag.data?.tt_name || '')
  .filter((name : string) => name.length) || []
